import { render, staticRenderFns } from "./UploadBox.vue?vue&type=template&id=05a694fc&scoped=true"
import script from "./UploadBox.vue?vue&type=script&lang=js"
export * from "./UploadBox.vue?vue&type=script&lang=js"
import style0 from "./UploadBox.vue?vue&type=style&index=0&id=05a694fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a694fc",
  null
  
)

export default component.exports